import { PlansSection, PropertyDataSection } from './components';

import './index.css';

interface TabsPropertyDataTheftInsuranceProps {
  id: number;
  duplicateId?: number;
}

export const TabsPropertyDataTheftInsurance = ({
  id,
  duplicateId,
}: TabsPropertyDataTheftInsuranceProps) => {
  return (
    <div className='container-tabs-property-data-theft-insurance'>
      <PlansSection id={id} duplicateId={duplicateId} />

      <PropertyDataSection id={id} duplicateId={duplicateId} />
    </div>
  );
};
